export default __webpack_public_path__ + "static/AN_Loop_vp9-d7946ca2050be1cbe8d736a9f5859168.webm";